import { COMPLIANCE, type PublicConfig } from '@licita/contracts';
import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000';
const NOME = 'Painel do cliente';

function App() {
  const [cfg, setCfg] = useState<PublicConfig | null>(null);
  const [erro, setErro] = useState(false);
  useEffect(() => {
    fetch(`${API_URL}/config`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((c: PublicConfig) => setCfg(c))
      .catch(() => setErro(true));
  }, []);
  const toggle = () => {
    const t = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = t;
    try {
      localStorage.setItem('theme', t);
    } catch {}
  };
  return (
    <main>
      <span className="logo mono">
        <svg width="28" height="28" viewBox="0 0 64 64" aria-hidden="true">
          <rect width="64" height="64" rx="14" fill="#0A0B10" />
          <path d="M20 14v30h20" fill="none" stroke="#ECEDF2" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M30 38l6 6 12-14" fill="none" stroke="#7B86FF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        licita<span className="dev">.dev</span>
        <span className="cursor" aria-hidden="true" />
      </span>
      <h1>{NOME}: em construção</h1>
      <p>Esta é a fase 1 (infraestrutura e site). O {NOME.toLowerCase()} chega nas próximas fases.</p>
      <p className="small">
        {erro ? (
          'A API não respondeu.'
        ) : cfg ? (
          <>
            API no ar · ambiente <span className="chip mono">{cfg.env}</span>
          </>
        ) : (
          'Consultando a API…'
        )}
      </p>
      <p className="small">{COMPLIANCE.semGarantia}</p>
      <p>
        <button type="button" onClick={toggle} aria-label="Alternar tema">
          Alternar tema
        </button>{' '}
        <a href="https://licita.dev/">licita.dev</a>
      </p>
    </main>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
